import { Injectable } from '@angular/core';
import {backendURL} from "../constants/globalConstants";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BackendDataService {

  brands: string[] = ["Loading"]
  countries: string[] = ["Loading"]
  regions: string[] = ["Loading"]
  regionsTw: string[] = ["Loading"]
  lastSyncTimestamp: string = "Unknown"

  constructor(private http: HttpClient) { }

  refreshTimestamp(){
    this.http.get<{last_sync: string}>(backendURL + "/json/timestamp.json").pipe(catchError((err) => {
      console.log(err);
      return of(err);
    })).subscribe((data) => {
      this.lastSyncTimestamp = data.last_sync;
    })
  }
}
